import apiV2 from '../api/v2';

export type ActionBy = 'GP' | 'orthodontist' | 'ODO';

// Where refinement-needed will send the case; the backend picks Ref-1 or the ODO-managed Ref-2 lane.
export interface RefinementTarget {
    internalStatus: string;
    externalStatus: string;
    actionRequired: string | null;
    actionBy: ActionBy | null;
}

export async function fetchRefinementTarget(patientId: string): Promise<RefinementTarget> {
    const response = await apiV2.get<{ success: boolean; data: RefinementTarget }>(
        `/patients/${patientId}/workflow/in-treatment/refinement-needed/target`
    );
    return response.data.data;
}
